import { ChangeDetectorRef, Component, NgZone, OnDestroy, effect } from '@angular/core';
import { LoginService } from '../login/login.service';
import { PaymentService } from './payment.service';
import { environment } from '../../../environments/environment';
import { paymentInfo } from '../../types/paymentInfo';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PopupService } from '../../core/services/popup/popup.service';
import { PaymentPopupComponent } from '../paymentResponse/payment-popup/payment-popup.component';
import { JwtService } from '../../shared/services/jwt/jwt.service';

declare var WPCL: any;

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    standalone: false
})

export class PaymentComponent implements OnDestroy {

    userValue: any;
    userId = '';
    userIds: any = [];
    amountToPay = '';
    customOptions: any;
    errorMessage = '';
    paymentError = false;
    languageCode = '';
    countryCode = '';
    paymentLoading = false;
    previousRoute = '';
    amountDetails: any;
    asstAmount = {};
    adtAmount = {};
    clipAmount = {};
    clipAdtAmount = {};
    docAmount = {};
    priceId = 0;
    type = '';
    isLoader = false;
    private iframeObserver?: MutationObserver;

    constructor(private paymentService: PaymentService, private ngZone: NgZone, private router: Router,
                private cdr: ChangeDetectorRef,
                private paymentInfo: paymentInfo, private translate: TranslateService,
                private loginService: LoginService, private popupService: PopupService, private jwtService: JwtService) {

        // Use effect to react to signal changes
        effect(() => {
            this.userValue = this.loginService.gigyaResponse; 
            this.previousRoute = this.paymentService.routeInfo;
            this.asstAmount = this.paymentService.asstAmount;
            this.adtAmount = this.paymentService.adtAmount;
            this.clipAmount = this.paymentService.clipAmount;
            this.clipAdtAmount = this.paymentService.clipAdtAmount;
            this.docAmount = this.paymentService.docAmount;
                 
            if(this.userValue) {
                this.userId = this.userValue.userId;
                this.countryCode = this.userValue.countryCode;
                this.languageCode = this.userValue.languageCode;
            }
            if(this.previousRoute && this.previousRoute === 'assistance' && this.asstAmount && Object.keys(this.asstAmount).length) {
                this.amountDetails = this.asstAmount;
                this.amountToPay = (this.asstAmount as any).priceTTC;
                this.userId = (this.asstAmount as any).userId;
                this.priceId = (this.asstAmount as any).assistanceOfferId;
                this.type = (this.asstAmount as any).type;
            } else if(this.docAmount && Object.keys(this.docAmount).length) {
                this.amountDetails = this.docAmount;
                this.amountToPay = (this.docAmount as any).priceTTC;
                this.userId = (this.docAmount as any).userId;
                this.type = (this.docAmount as any).type;
                if((this.docAmount as any).type === 'DO') {
                    this.priceId = (this.docAmount as any).priceId;
                } else {
                    this.priceId = (this.docAmount as any).reprogId;
                }
            } else if(this.adtAmount && Object.keys(this.adtAmount).length) {
                this.amountDetails = this.adtAmount;
                this.amountToPay = (this.adtAmount as any).priceTTC;
                this.userId = (this.adtAmount as any).userId;
                this.priceId = (this.adtAmount as any).adtSubscriptionOfferId;
                this.type = (this.adtAmount as any).type;
            } else if(this.clipAmount && Object.keys(this.clipAmount).length) {
                this.amountDetails = this.clipAmount;
                this.amountToPay = (this.clipAmount as any).priceTTC;
                this.userId = (this.clipAmount as any).userId;
                this.priceId = (this.clipAmount as any).clipSubscriptionOfferId;
                this.type = (this.clipAmount as any).type;
            } else if(this.clipAdtAmount && Object.keys(this.clipAdtAmount).length) {
                this.amountDetails = this.clipAdtAmount;
                this.amountToPay = (this.clipAdtAmount as any).priceTTC;
                this.userId = (this.clipAdtAmount as any).userId;
                this.priceId = (this.clipAdtAmount as any).clipAdtSubscriptionOfferId;
                this.type = (this.clipAdtAmount as any).type;
            }
            if(this.userId && this.amountToPay) {
                this.setLoaderState(true);
                this.getPaymentPage();
            }
        });
    }

    getPaymentPage() {
        this.customOptions = {
            iframeIntegrationId: 'libraryObject',
            iframeHelperURL: environment.app_url + '/helper.html',
            iframeBaseURL: environment.app_url,
            type: 'iframe',
            target: 'custom-html',
            accessibility: false,
            debug: false,
            language: this.languageCode,
            preferredPaymentMethod: 'VISA-SSL',
            successURL: environment.app_url + '/paymentResponse',
            cancelURL: environment.app_url + '/offers/' + this.previousRoute + '?clearParams=true',
            failureURL: environment.app_url + '/paymentResponse',
            pendingURL: environment.app_url + '/paymentResponse',
            errorURL: environment.app_url + '/paymentResponse'
        };
        this.setLoaderState(true);
        this.errorMessage = '';
        this.paymentLoading = true;
        this.ngZone.run(() => {
            let amountInfo = { "userId": this.userId, "priceId": this.priceId, "offerType": this.type };
            let purchaseData: string = this.jwtService.encode(amountInfo, "secret");
            this.paymentService.getPaymentPage(purchaseData).subscribe((response: any) => {
                this.paymentInfo = response;
                if(!this.paymentInfo || (this.paymentInfo as any).errorCode) {
                    this.paymentError = true;
                    this.errorMessage = this.translate.instant("PAYMENT_ERROR_MESSAGE");
                    this.setLoaderState(false);
                    this.showErrorPop();
                } else {
                    this.paymentService.setPaymentDetails(response);                
                    this.paymentService.setPaymentDetails(this.paymentInfo);

                    // Store token before payment gateway redirect
                    const accessToken = this.loginService.accessToken.getValue();
                    if(accessToken) {
                        sessionStorage.setItem('currentToken', accessToken);
                    }

                    const libraryObject = new WPCL.Library();
                    this.customOptions.url = this.paymentInfo.urlContent;
                    this.trackIframeLoading();
                    libraryObject.setup(this.customOptions);
                    dispatchEvent(new Event('load'));
                    this.paymentLoading = false;
                }
            },  (err: any) => {
                    this.errorMessage = this.translate.instant("PAYMENT_REFRESH_ERROR");
                    this.paymentLoading = false;
                    this.paymentError = true;
                    this.setLoaderState(false);
                    this.showErrorPop();
                }
            );
        });
    }

    showErrorPop() {
        this.popupService.openDialog(PaymentPopupComponent, {
                data: { message : this.errorMessage}
            }
        );
    }

    closeErrPop() {
        this.paymentError = false;
        this.router.navigateByUrl(this.previousRoute);
    }

    private trackIframeLoading() {
        this.iframeObserver?.disconnect();
        const container = document.getElementById('custom-html');
        if(!container) {
            this.setLoaderState(false);
            return;
        }

        const existingIframe = container.querySelector('iframe');
        if(existingIframe) {
            this.attachIframeLoadListener(existingIframe as HTMLIFrameElement);
            return;
        }

        this.iframeObserver = new MutationObserver(() => {
            const iframe = container.querySelector('iframe');
            if(iframe) {
                this.attachIframeLoadListener(iframe as HTMLIFrameElement);
                this.iframeObserver?.disconnect();
                this.iframeObserver = undefined;
            }
        });

        this.iframeObserver.observe(container, { childList: true, subtree: true });
    }

    private attachIframeLoadListener(iframe: HTMLIFrameElement) {
        iframe.addEventListener('load', () => {
            this.ngZone.run(() => {
                this.setLoaderState(false);
            });
        }, { once: true });
    }

    private setLoaderState(isLoading: boolean) {
        this.isLoader = isLoading;
        this.cdr.detectChanges();
    }

    ngOnDestroy() {
        this.iframeObserver?.disconnect();
    }
    
}